import { route } from '../helpers';

import urls from '../../urls';
import config from '../../config';
import DimensionsStore from '../../stores/DimensionsStore';
import { GridPages, PointStages, JourneyPlannerLayout } from '../../constants/AppConstants';

export default route(PointStages.SEARCH_RESULTS, {
    async onEnter ({ params, location }, replace) {
        const targetLayout = config.get('journeyPlannerDefaultLayout');
        const isMobileWidth = DimensionsStore.isMobileWidth();

        let routeName;
        if (isMobileWidth || targetLayout === JourneyPlannerLayout.LIST) {
            routeName = PointStages.CHOOSE_OUTWARD;
        } else {
            routeName = GridPages.SERVICES;
        }
        replace(urls.location(routeName, params, location.query));
    }
});
